export const splitArray = (source: any[], size: number) => {
  const result = []
  for (let i = 0; i < source.length; i += size) {
    result.push(source.slice(i, i + size))
  }
  return result
}

export const uniqBy = (arr: any[], predicate: string) => {
  return [
    ...arr
      .reduce((map, item) => {
        const key = item === null || item === undefined ? item : item[predicate]

        map.has(key) || map.set(key, item)

        return map
      }, new Map())
      .values(),
  ]
}
